import React from 'react';
import { SolutionPage } from '../../components/solutions/SolutionPage';
import { SolutionDepthSection } from '../../components/solutions/SolutionDepthSection';
export function EducationPage() {
  return <SolutionPage id="education" data-id="element-2750" data-mp="6r9aoo0anlan">
      <SolutionDepthSection id="education" data-id="element-2751" data-mp="6saxfpqo9w87" />
    </SolutionPage>;
}